import semver from "semver"

// get the latest of all the solve tags
export const getSolverStatusTag = (tags = []) => {
  const solverStati = tags.filter((tag) => tag.name == "solve")
  return solverStati?.length > 0 ? getLatestTag(solverStati) : "none"
}

// list of all the solve tags
export const getSolverStatusTags = (tags = []) => {
  return tags.filter((tag) => tag.name == "solve")
}

export const getObjectCountTag = (tags = []) => {
  const solverCount = tags.filter((tag) => tag.name == "solve-satellites-count")
  return solverCount?.length > 0 ? getLatestTag(solverCount) : { value: 0 }
}

export const getObjectCountTags = (tags = []) => {
  return tags.filter((tag) => tag.name == "solve-satellites-count")
}

/**
 * From a list of tags get the latest tag based on the algorithm_version (which is a semantic ver)
 * @param tags
 * @returns {*}
 */
function getLatestTag(tags) {
  const tagsByKey = tags.reduce((r, tag) => {
    let key = "0.0.0"
    if (tag["algorithm_version"]) {
      key = tag.algorithm_version.join(".")
    }
    r[key] = tag
    return r
  }, {})
  return tagsByKey[getLatestVersion(Object.keys(tagsByKey))]
}

/**
 * From a list of semantic version numbers get the latest version
 * @param versions
 * @returns {*|null}
 */
function getLatestVersion(versions) {
  if (!Array.isArray(versions) || versions.length === 0) {
    return null
  }
  // Sort the versions in descending order using semver
  const sortedVersions = versions.sort((a, b) => semver.rcompare(a, b))
  // The first element will be the latest version
  return sortedVersions[0]
}
